<template>
  <component :is="layout"></component>
</template>
<script>
import { baseApiUrl } from "@/global";
import axios from "axios";
export default {
  computed: {
    layout() {
      return "layout-page";
    }
  },
  data() {
    return {
      tenant: {}
    };
  },
  methods: {
    init() {
      const params = (new URL(document.location)).searchParams;
      const paramFilter = {nick_name: params.get("on")}
      axios.post(`${baseApiUrl}/ftbnn/`, paramFilter)
      .then(res => {
            this.tenant = res.data[0]
console.log('tenant', this.tenant)

            this.redirectPage()
      }) 
    },

    redirectPage() {
      if(this.tenant.serial_number !== null ) {
        this.$store.commit("setTenant", this.tenant);        
        this.$router.push({ name: "signin" }); 
      } else {
        this.$router.push({ name: "erro404" });
      }
    }
  },
  created() {
    this.init();
  }
};
</script>
